/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in local storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 5;
  static eventName = 'recently-viewed:change';

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    try {
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
      document.dispatchEvent(new Event(this.eventName));
    } catch {
      // Browsing and purchasing remain available when storage is blocked.
    }
  }

  static clearProducts() {
    try {
      localStorage.removeItem(this.#STORAGE_KEY);
      document.dispatchEvent(new Event(this.eventName));
    } catch {
      // Storage is optional for recently viewed products.
    }
  }

  /**
   * Retrieves the list of recently viewed products from local storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    try {
      const products = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
      return Array.isArray(products) ? [...new Set(products.filter(id => typeof id === 'string' && /^\d+$/.test(id)))].slice(0, this.#MAX_PRODUCTS) : [];
    } catch {
      return [];
    }
  }
}
